import { render, staticRenderFns } from "./DashboardBonusWidget.vue?vue&type=template&id=c7d71e86&scoped=true"
import script from "./DashboardBonusWidget.vue?vue&type=script&lang=js"
export * from "./DashboardBonusWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardBonusWidget.vue?vue&type=style&index=0&id=c7d71e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d71e86",
  null
  
)

export default component.exports